import { useNavigate } from "react-router-dom";
import { Card } from "../../../components/card/card.jsx";
import TableBody from "../../../components/table/TableBody.jsx";

function Vehicles() {
	const navigate = useNavigate();

	const handleAddVehicle = (send) => {
		navigate("/vehiclesDetails", { state: send });
	};

	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<h1 className="page-header mb-0">Vehículos</h1>
				</div>
				<div className="ms-auto">
					<button onClick={() => handleAddVehicle({ type: "add" })} className="btn btn-outline-theme">
						<i className="fa fa-plus-circle fa-fw me-1"></i> Agregar Vehículo
					</button>
				</div>
			</div>

			<Card>
				<div className="tab-content p-4">
					<div className="tab-pane fade show active" id="allTab">
						<TableBody table={"vehicles"} query={"vehicles"} />
					</div>
				</div>
			</Card>
		</div>
	);
}

export default Vehicles;
